import { GqlRequestOptions } from '@common/api-request';

import { getZonlyEstimateShippingInfo } from '../graphql/zonly-estimate-shipping-info.2';
import { queryOptions } from '../lib/queryHelpers';
import { checkValidCatalogProductId } from '../lib/utils';

export interface GetZonlyEstimateShippingInfoQueryOptionParams {
  catalog_product_id: string;
  final_price: number | null;
  enabled?: boolean;
}

export function zonlyEstimateShippingInfoQueryOption(
  params: GetZonlyEstimateShippingInfoQueryOptionParams,
  options?: GqlRequestOptions,
) {
  const enabled = params.enabled === undefined ? true : params.enabled;
  return {
    queryKey: ['getZonlyEstimateShippingInfo'],
    queryFn: async function () {
      const { data } = await getZonlyEstimateShippingInfo(
        { input: { catalog_product_id: params.catalog_product_id, final_price: params.final_price } },
        { ...options, show_alert: false },
      );
      return data?.pdp_zigzin_shipping_base_info;
    },
    ...queryOptions,
    enabled: enabled && checkValidCatalogProductId(params.catalog_product_id),
  };
}
